export default {"src":"https://static.influitive.com/_next/static/media/videoCamera.f786ef9d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};